import { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from '../Loader';
import JsonData from '../../json';

const devEnv = process.env.NODE_ENV !== "production";
const { REACT_APP_DEV_URL, REACT_APP_PROD_URL } = process.env;
let url = "http://localhost:5002";

const Section2 = () => {
    let [div1, setDiv1] = useState("");
    let [div2, setDiv2] = useState("");
    let [defaultImage, setDefaultImage] = useState("");
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        //ajax call
        setLoading(true);
        setDiv1(JsonData["second-section"][0]);
        setDiv2(JsonData["second-section"][1]);
        setDefaultImage(JsonData["second-section"][1].image);
        setLoading(false);
    }, []);

    let chnageImage = (url) => {
        setDefaultImage(url);
    };

    return (
        <>
            {!loading ?
                <div className="section2_flex" id="movie-section">
                    <div className="section2_div1">
                        <img className="section2_div1_image" src={div1.image} alt="" />
                        <span className="section2_div1_font"><span>Prime Video: Recommended for you</span><br /><h6>{div1.name}</h6></span>
                    </div>

                    <div className="section2_div2">
                        <div>
                            <h1 className="section2_div2_font">Best Seller in Laptops</h1>
                            <img className="section2_div2_image" src={defaultImage} alt="" />
                        </div>

                        <div className="section2_div2_smallPics">
                            {div2.about?.images.map((data, i) => (
                                <img className="section2_div2_smallPics_inner" key={i} src={data} alt="image" onClick={() => { chnageImage(data) }} />
                            ))}
                        </div>
                    </div>
                </div> :
                <Loader />}
        </>
    )
}

export default Section2;